/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('MainCtrl', function(
    $rootScope,
    $scope,
    $location,
    $http,
    $uibModal,
    $window,
    $filter,
    api_url,
    identity,
    Term,
    WallsService,
    intraprof_web_url,
    language_url,
    loginModal,
    features
) {
    $scope.features = features;
    $scope.update = false;
    let version = undefined;
    $scope.intraprof_web_url = intraprof_web_url;
    $scope.language_url = language_url;

    $scope.dropdown_status =
        {open: false};

    $scope.focus_search = function() {
        $scope.dropdown_status.open = !$scope.dropdown_status.open;

        if (true === $scope.dropdown_status.open) {
  		    $scope.$broadcast('focus');
		}
    };

    identity
    .$promise
    .then(function(me) {
        $scope.me = me;
        return amIProf();}).catch(error => loginModal.open('login'));

    $scope.promo_walls  = WallsService.getPromoWalls();
    $scope.static_walls = WallsService.getStaticWalls();
    $scope.unread       = WallsService.getUnread();

	function determineApiVersion() {
        if ($scope.me != null) {
            $http.get(`${api_url}/version`).success(function(data) {
                if ((undefined !== version) && (version !== data)) {
                    $scope.update = true;
                    clearInterval(interval);
                }
                version = data;
            });
        }
	}
	
    var interval = setTimeout(() => setInterval(determineApiVersion, 10 * 60 * 1000), 2 * 60 * 1000);

    $scope.$on('$locationChangeSuccess', (evt, absNewUrl, absOldUrl) => $rootScope.oldUrl = absOldUrl);

    $scope.$on('auth:login', () => $window.location.reload());

    var amIProf = function() {
        const allow_access = $filter('authorizeUserFilter')($scope.me.groups, ['adm', 'student', 'prepintra_adm']);
        if (Array.from($scope.me.groups).includes('prof') && (allow_access === false)) {
            return $window.location.href = intraprof_web_url;
        }
    };

    $scope.iAmStudent = () => ($scope.me != null) && ($scope.me.groups != null) && Array.from($scope.me.groups).includes('student');

    $scope.iAmProfOrAdm = () => ($scope.me != null) && ($scope.me.groups != null) && (Array.from($scope.me.groups).includes('prof') || Array.from($scope.me.groups).includes('adm'));

    $scope.searchFct = search_query => $location.path(`/search/${search_query}`);

    $scope.iAmProfANDStudent = () => ($scope.me != null) && ($scope.me.groups != null) && Array.from($scope.me.groups).includes('prof') && Array.from($scope.me.groups).includes('student');

    $scope.iAmProfORStudent = function() {
        if (($scope.me == null) || ($scope.me.groups == null)) { return false; }
        if ($scope.iAmProfANDStudent()) { return false; }
        switch (false) {
            case !Array.from($scope.me.groups).includes('prof'): return 'prof';
            case !Array.from($scope.me.groups).includes('student'): return 'student';
        }
    };

    $scope.iAmAdmin = () => ($scope.me != null) && ($scope.me.groups != null) && Array.from($scope.me.groups).includes('adm');

    $scope.minHeight = $(window).height();

    $scope.openModal = () => $uibModal.open({
        templateUrl: 'directives/widget/help/modal_template.html',
        controller:  'ModalHelpCtrl',
        resolve: {
            me() { return $scope.me; },
            location() { return $scope.location; }
        }
    });

    $scope.openChangelog = function() {
        const modal_instance = $uibModal.open({
            templateUrl: 'partials/modals/changelogModal.html',
            controller:  'ChangelogCtrl'
        });

        // Si on ne fait aucune action dans le catch, la modale met beaucoup de temps à
        // se fermer lors d'un backdrop.
        // En appelant la promise la modale se ferme juste après un click hors
        // de la modale.
        return modal_instance
        .result
        .catch(function() {
            let close;
            return close = 'backdrop close';
        });
    };

    return $scope.openHumanRoads = () => $uibModal.open({
        templateUrl: 'partials/modals/humanRoads.html',
        controller:  'HumanRoadsModalCtrl'
    });
});
